export default "__VITE_ASSET__05f2f1ad__"